/* eslint-disable max-statements */
import axios from 'axios';
import React, { useRef, useState } from 'react';
import { useInfiniteQuery } from 'react-query';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import { globalEnv } from '../../../../../config/baseConfig';
import LazyImage from '../../Components/imageComponent';
import { ModalEnum } from '../SignupTopicTableWithReferral';
import { useNavigate } from 'react-router-dom';

export const ReferredTopicUserListModalContent = ({
	topicCode,
	referralCode,
	modalType
}: {
	topicCode: string;
	referralCode: string;
	modalType: ModalEnum;
}) => {
	const [isPaused, setPause] = useState(false);
	const [userList, setUserList] = useState<any[]>([]);
	const [page, setPage] = useState(1);
	const [totalNumberOfUsers, setTotalNumberOfUsers] = useState(0);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const fetchUsers = async () => {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const endpoint =
			modalType === ModalEnum.ACTIVE_USERS
				? `${globalEnv.BASE_URL}/signup-topic/get-referral-code-active-users?topicCode=${topicCode}&referralCode=${referralCode}`
				: `${globalEnv.BASE_URL}/signup-topic/get-referral-code-users?topicCode=${topicCode}&referralCode=${referralCode}`;

		const { data } = await axios.get(`${endpoint}`, config);
		let userListCopy = [];
		if (page > 1) userListCopy = userList.slice();
		data.users.map((item: any) => userListCopy.push(item));

		setUserList(userListCopy);
		setTotalNumberOfUsers(data.users.length);
		return {
			data
		};
	};

	const { isFetching } = useInfiniteQuery([page], fetchUsers, {
		keepPreviousData: false,
		cacheTime: 0,
		refetchOnWindowFocus: false
	});

	const listInnerRef = useRef<null>(null);

	const onScroll = () => {
		if (userList.length < totalNumberOfUsers && userList.length > 0)
			if (!isFetching) {
				if (listInnerRef.current) {
					const { scrollTop, scrollHeight, clientHeight } =
						listInnerRef.current;
					if (scrollTop + clientHeight >= scrollHeight - 600) {
						if (!isPaused) {
							setPage(page + 1);
							setPause(true);
						}
					} else undoPause();
				}
			}
	};

	const undoPause = () => {
		setTimeout(() => {
			setPause(false);
		}, 1000);
	};

	return (
		<div>
			<div
				className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
                 w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
			>
				{/* Users Count Header */}
				<div className="bg-white dark:bg-gray-900 px-6 py-4 border-b border-gray-200 dark:border-gray-700 rounded-t-xl">
					<div className="mx-auto max-w-lg w-10/12">
						<h3 className="text-lg font-semibold text-gray-900 dark:text-white">
							{modalType === ModalEnum.ACTIVE_USERS
								? 'Active Users'
								: 'Signed Up Users'}
							: {totalNumberOfUsers}
						</h3>
					</div>
				</div>

				<section
					className="relative bg-white w-full max-h-screen overflow-y-auto h-screen
                                dark:bg-gray-900 transition-colors duration-300 rounded-b-xl"
					onScroll={() => onScroll()}
					ref={listInnerRef}
				>
					<div className="mx-auto max-w-lg w-10/12 my-10">
						{userList.map((item: any) => (
							<UserElement
								id={item._id}
								username={item.username}
								photo={item.photo}
							/>
						))}
					</div>
				</section>
			</div>
		</div>
	);
};

function UserElement({
	id,
	username,
	photo
}: {
	id: string;
	username: string;
	photo: string;
}) {
	const navigate = useNavigate();
	return (
		<div className="relative group bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden ">
			<div
				className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
				onClick={() => {
					navigate(`../user/${id}`);
				}}
			>
				<div className="mr-2">
					<LazyImage
						photo={
							photo != null
								? photo
								: `https://api.dicebear.com/7.x/bottts/svg?seed=${username}`
						}
						dimesnions={'25'}
						loaderDimesnions={23}
					/>
				</div>
				<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white ">
					{username}
				</div>
			</div>
		</div>
	);
}
